import i18n from "i18next";
import { initReactI18next } from "react-i18next";

/** Lazy-load de JSON por idioma/namespace */
const localeFiles = import.meta.glob("../locales/*/*.json", { eager: false });

async function loadLocale(lng, ns) {
  const key = `../locales/${lng}/${ns}.json`;
  if (!localeFiles[key]) {
    if (import.meta.env.DEV) console.warn(`[i18n] No existe ${key}`);
    return {};
  }
  const mod = await localeFiles[key]();
  return mod.default;
}

i18n.use(initReactI18next).init({
  lng: (() => {
    try {
      return localStorage.getItem("lang") || "es";
    } catch {
      return "es";
    }
  })(),
  fallbackLng: "es",
  defaultNS: "common",
  ns: ["common"],
  resources: {}, // se agregan on-demand
  interpolation: { escapeValue: false },
  react: { useSuspense: false }, // evita requerir <Suspense>
});

/** Precarga namespaces en tiempo de ejecución */
export async function ensureNamespaces(lng, namespaces) {
  for (const ns of namespaces) {
    if (!i18n.hasResourceBundle(lng, ns)) {
      const data = await loadLocale(lng, ns);
      i18n.addResourceBundle(lng, ns, data, true, true);
    }
  }
}

export default i18n;
